import React from 'react';
import {
  Colors,
  Divider,
  Flex,
  IconChevronRight,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { useGoodsBasic } from '../../queries/useGoodsBasic';
import { isNotNil } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';

export const CategoryInfo: React.FC = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { openDeeplink } = useOpenDeeplink();

  return (
    <>
      <Divider size={'medium'} />
      {goodsBasic?.display_categories.map(category => (
        <Flex.Row
          key={category.name}
          padding={{ horizontal: 16, vertical: 16 }}
          gap={12}
          alignItems={'center'}
          onPress={() => {
            openDeeplink(category.deeplink);
          }}
        >
          {isNotNil(category.representative_image_url) && (
            <RemoteImage
              uri={category.representative_image_url}
              width={43}
              height={51}
              borderRadius={'small'}
              doAnimate={false}
            />
          )}
          <Flex flex={1} justifyContent={'center'} gap={2}>
            <Typography type={'body3'} color={'content_tertiary'}>
              다른 {category.name}도 궁금하다면?
            </Typography>
            <Typography type={'subtitle1'} color={'content_primary'}>
              {category.name} 전체 상품 보기
            </Typography>
          </Flex>
          <IconChevronRight fill={Colors.content_tertiary} size={16} />
        </Flex.Row>
      ))}
      <Divider size={'medium'} />
    </>
  );
};
